module.exports = __webpack_public_path__ + "img/gyonyoru_szuleim_apa_buborekokkal.81005bd1.jpg";